"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var Droppable = react_beautiful_dnd_1.Droppable;
var DragDropContext = react_beautiful_dnd_1.DragDropContext;
var DragDropContainer = function (props) {
    var _a = props.onDragEnd, onDragEnd = _a === void 0 ? function () { } : _a, children = props.children, _b = props.isDisabled, isDisabled = _b === void 0 ? false : _b;
    var dragEndHandler = (0, react_1.useCallback)(function (result) {
        if (!result.destination)
            return;
        onDragEnd(result);
    }, [onDragEnd]);
    return (react_1.default.createElement(DragDropContext, { onDragEnd: dragEndHandler },
        react_1.default.createElement(Droppable, { droppableId: "droppable", isDropDisabled: isDisabled }, function (provided) { return (react_1.default.createElement("div", __assign({}, provided.droppableProps, { ref: provided.innerRef }),
            children,
            provided.placeholder)); })));
};
exports.default = DragDropContainer;
